export const isLocal = false;
export const isHomolog = false;

export const pathName = isLocal ? 'http://localhost:3001' : 'https://kiddlepass-partner-api.herokuapp.com';
export default pathName;
